import { Typography } from "@mui/material";
import { format } from "date-fns";
import { ja } from "date-fns/locale";
import React from "react";
import { StoreData } from "../../Objects/StoreInterface";

interface StoreCloseDateProps {
    storeData: StoreData
    variant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "subtitle1" | "subtitle2" | "body1" | "body2" | "caption" | "button" | "overline" | "inherit" | undefined
}

const StoreCloseDate: React.FC<StoreCloseDateProps> = ({
    storeData,
    variant
}) => {
    return (
        <>
            {storeData.str_close_date &&
                <Typography
                    variant={variant}
                >
                    {format(storeData.str_close_date, "yyyy年MM月dd日 EEEE", {locale: ja})}
                </Typography>
            }
        </>
    );
}

export default StoreCloseDate